var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { all, call, put, takeLatest } from 'redux-saga/effects';
import { getCognitoSession } from '@/utils/cognito';
import { login, logout, getUserSetting, getUserFunctions } from './repository';
import { CHECK_AUTH_REQUEST, LOGIN_REQUEST, LOGOUT_REQUEST, UPDATE_USER_INFO, } from './actionTypes';
import { checkAuthFailed, checkAuthSuccess, loginRequestFailed, loginRequestSuccess, logoutRequestFailed, logoutRequestSuccess, updateUserInfoSuccess, } from './reducer';
import _ from 'lodash';
import { settingsService } from '@/services/setting/application/settings';
import { toggleLoadingMain } from '../layout/layout-reducer';
import { getValueSettingByKey } from '@/utils/helpers';
import { SETTING_KEYS } from '@/utils/constants';
function fetchLoginSaga(action) {
    var response, userSetting, userFunctions, settings_app, sideMenuSetting, backgroundSetting, defaultUI, e_1;
    var _a, _b, _c, _d, _e, _f;
    return __generator(this, function (_g) {
        switch (_g.label) {
            case 0:
                _g.trys.push([0, 8, , 11]);
                return [4 /*yield*/, call(login, action.payload)];
            case 1:
                response = _g.sent();
                return [4 /*yield*/, put(toggleLoadingMain())];
            case 2:
                _g.sent();
                return [4 /*yield*/, call(getUserSetting)];
            case 3:
                userSetting = _g.sent();
                if (userSetting.data) {
                    response.setting = userSetting.data;
                }
                return [4 /*yield*/, call(getUserFunctions)];
            case 4:
                userFunctions = _g.sent();
                if (userFunctions.data) {
                    response.functions = userFunctions.data;
                }
                return [4 /*yield*/, call(settingsService.getListSettings)];
            case 5:
                settings_app = _g.sent();
                sideMenuSetting = [];
                backgroundSetting = '';
                defaultUI = void 0;
                if (settings_app.data) {
                    sideMenuSetting =
                        JSON.parse(settings_app.data.Items.find(function (x) { return x.setting_key === 'SIDE_MENU'; }).value) || [];
                    backgroundSetting =
                        settings_app.data.Items.find(function (x) { return x.setting_key === 'BACKGROUND'; })
                            .value || 'login-background.png';
                    defaultUI = JSON.parse(getValueSettingByKey(settings_app.data.Items, SETTING_KEYS.DEFAULT_UI_PREFERENCES) || '');
                }
                return [4 /*yield*/, put(loginRequestSuccess({
                        userInfo: __assign(__assign({}, response), { setting: __assign(__assign({}, response.setting), { theme: (_a = defaultUI.theme) !== null && _a !== void 0 ? _a : (_b = response.setting) === null || _b === void 0 ? void 0 : _b.theme, font: (_c = defaultUI.font) !== null && _c !== void 0 ? _c : (_d = response.setting) === null || _d === void 0 ? void 0 : _d.font, language: (_e = defaultUI.language) !== null && _e !== void 0 ? _e : (_f = response.setting) === null || _f === void 0 ? void 0 : _f.language }) }),
                        menus: sideMenuSetting,
                        background: backgroundSetting,
                        configureSettings: {
                            avatarSelectionEnabled: !!getValueSettingByKey(settings_app.data.Items, SETTING_KEYS.AVATAR_SELECTION_ENABLED),
                            securityScreenEnabled: !!getValueSettingByKey(settings_app.data.Items, SETTING_KEYS.SECURITY_SCREEN_ENABLED),
                            themeAppearanceScreenEnabled: !!getValueSettingByKey(settings_app.data.Items, SETTING_KEYS.THEME_APPEARANCE_SCREEN_ENABLED),
                            showRemoveDisplayButton: !!getValueSettingByKey(settings_app.data.Items, SETTING_KEYS.SHOW_REMOVE_DISPLAY_BUTTON),
                        }
                    }))];
            case 6:
                _g.sent();
                return [4 /*yield*/, put(toggleLoadingMain())];
            case 7:
                _g.sent();
                return [3 /*break*/, 11];
            case 8:
                e_1 = _g.sent();
                return [4 /*yield*/, put(loginRequestFailed({
                        error: {
                            type: 'NormalError',
                            message: 'Authentication failed',
                        },
                    }))];
            case 9:
                _g.sent();
                return [4 /*yield*/, put(toggleLoadingMain())];
            case 10:
                _g.sent();
                return [3 /*break*/, 11];
            case 11: return [2 /*return*/];
        }
    });
}
function updateUserInfo(action) {
    var user, userSetting, userFunctions, settings_app, sideMenuSetting, backgroundSetting, e_2;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                _a.trys.push([0, 7, , 9]);
                return [4 /*yield*/, put(toggleLoadingMain())];
            case 1:
                _a.sent();
                user = _.cloneDeep(action.payload);
                return [4 /*yield*/, call(getUserSetting)];
            case 2:
                userSetting = _a.sent();
                if (userSetting.data) {
                    user.userInfo.setting = userSetting.data;
                }
                return [4 /*yield*/, call(getUserFunctions)];
            case 3:
                userFunctions = _a.sent();
                if (userFunctions.data) {
                    user.userInfo.functions = userFunctions.data;
                }
                return [4 /*yield*/, call(settingsService.getListSettings)];
            case 4:
                settings_app = _a.sent();
                sideMenuSetting = [];
                backgroundSetting = '';
                if (settings_app.data) {
                    sideMenuSetting =
                        JSON.parse(settings_app.data.Items.find(function (x) { return x.setting_key === 'SIDE_MENU'; }).value) || [];
                    backgroundSetting =
                        settings_app.data.Items.find(function (x) { return x.setting_key === 'BACKGROUND'; })
                            .value || 'login-background.png';
                }
                return [4 /*yield*/, put(updateUserInfoSuccess({
                        userInfo: user.userInfo,
                        menus: sideMenuSetting,
                        background: backgroundSetting,
                    }))];
            case 5:
                _a.sent();
                return [4 /*yield*/, put(toggleLoadingMain())];
            case 6:
                _a.sent();
                return [3 /*break*/, 9];
            case 7:
                e_2 = _a.sent();
                console.log('Get user setting info failed');
                return [4 /*yield*/, put(toggleLoadingMain())];
            case 8:
                _a.sent();
                return [3 /*break*/, 9];
            case 9: return [2 /*return*/];
        }
    });
}
function checkAuthSaga() {
    var session, userSetting, userFunctions, settings_app, sideMenuSetting, backgroundSetting, defaultUI, e_3;
    var _a, _b, _c, _d, _e, _f;
    return __generator(this, function (_g) {
        switch (_g.label) {
            case 0:
                _g.trys.push([0, 6, , 8]);
                return [4 /*yield*/, call(getCognitoSession)];
            case 1:
                session = _g.sent();
                return [4 /*yield*/, call(getUserSetting)];
            case 2:
                userSetting = _g.sent();
                if (userSetting.data) {
                    session.userInfo.setting = userSetting.data;
                }
                return [4 /*yield*/, call(getUserFunctions)];
            case 3:
                userFunctions = _g.sent();
                if (userFunctions.data) {
                    session.userInfo.functions = userFunctions.data;
                }
                return [4 /*yield*/, call(settingsService.getListSettings)];
            case 4:
                settings_app = _g.sent();
                sideMenuSetting = [];
                backgroundSetting = '';
                defaultUI = void 0;
                if (settings_app.data) {
                    sideMenuSetting =
                        JSON.parse(settings_app.data.Items.find(function (x) { return x.setting_key === 'SIDE_MENU'; }).value) || [];
                    backgroundSetting =
                        settings_app.data.Items.find(function (x) { return x.setting_key === 'BACKGROUND'; })
                            .value || 'login-background.png';
                    defaultUI = JSON.parse(getValueSettingByKey(settings_app.data.Items, SETTING_KEYS.DEFAULT_UI_PREFERENCES) || '');
                }
                return [4 /*yield*/, put(checkAuthSuccess({
                        userInfo: __assign(__assign({}, session.userInfo), { setting: __assign(__assign({}, session.userInfo.setting), { theme: (_a = defaultUI.theme) !== null && _a !== void 0 ? _a : (_b = session.userInfo.setting) === null || _b === void 0 ? void 0 : _b.theme, font: (_c = defaultUI.font) !== null && _c !== void 0 ? _c : (_d = session.userInfo.setting) === null || _d === void 0 ? void 0 : _d.font, language: (_e = defaultUI.language) !== null && _e !== void 0 ? _e : (_f = session.userInfo.setting) === null || _f === void 0 ? void 0 : _f.language }) }),
                        menus: sideMenuSetting,
                        background: backgroundSetting,
                        configureSettings: {
                            avatarSelectionEnabled: !!getValueSettingByKey(settings_app.data.Items, SETTING_KEYS.AVATAR_SELECTION_ENABLED),
                            securityScreenEnabled: !!getValueSettingByKey(settings_app.data.Items, SETTING_KEYS.SECURITY_SCREEN_ENABLED),
                            themeAppearanceScreenEnabled: !!getValueSettingByKey(settings_app.data.Items, SETTING_KEYS.THEME_APPEARANCE_SCREEN_ENABLED),
                            showRemoveDisplayButton: !!getValueSettingByKey(settings_app.data.Items, SETTING_KEYS.SHOW_REMOVE_DISPLAY_BUTTON),
                        }
                    }))];
            case 5:
                _g.sent();
                return [3 /*break*/, 8];
            case 6:
                e_3 = _g.sent();
                return [4 /*yield*/, put(checkAuthFailed({
                        error: {
                            type: 'AuthError',
                            message: 'Check Authentication failed',
                        },
                    }))];
            case 7:
                _g.sent();
                return [3 /*break*/, 8];
            case 8: return [2 /*return*/];
        }
    });
}
function fetchLogoutSaga() {
    var e_4;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                _a.trys.push([0, 3, , 5]);
                return [4 /*yield*/, call(logout)];
            case 1:
                _a.sent();
                return [4 /*yield*/, put(logoutRequestSuccess())];
            case 2:
                _a.sent();
                return [3 /*break*/, 5];
            case 3:
                e_4 = _a.sent();
                return [4 /*yield*/, put(logoutRequestFailed({
                        error: {
                            type: 'NormalError',
                            message: 'Something went wrong',
                        },
                    }))];
            case 4:
                _a.sent();
                return [3 /*break*/, 5];
            case 5: return [2 /*return*/];
        }
    });
}
function authSaga() {
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, all([
                    takeLatest(LOGIN_REQUEST, fetchLoginSaga),
                    takeLatest(LOGOUT_REQUEST, fetchLogoutSaga),
                    takeLatest(CHECK_AUTH_REQUEST, checkAuthSaga),
                    takeLatest(UPDATE_USER_INFO, updateUserInfo),
                ])];
            case 1:
                _a.sent();
                return [2 /*return*/];
        }
    });
}
export default authSaga;
